
<p-dialog [(visible)]="showRejectDialog" (onHide)="close(null)" [modal]="true">
  <ng-template #header>
    Rejection Reason
  </ng-template>
  <div class="overlay" *ngIf="loading">
    <div class="spinner-wrapper">
      <app-spinner>
        <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
      </app-spinner>
    </div>
  </div>
  <div style="height: 275px;">
    <label>Select reason:</label>
    <p-listbox [options]="rejectionTypes"
               [(ngModel)]="selectedRejectionType"
               [multiple]="true"
               [checkbox]="true"
               [style]="{'width':'250px'}"
               (ngModelChange)="selectedRejectionTypeChange()">
    </p-listbox>
  </div>
  <div style="height: 115px;">
    <label>Comment:</label>
    <br />
    <textarea [(ngModel)]="rejectionDescription"
              size="30"
              [style]="{'width':'400px'}">
    </textarea>
    <p class="valdiation-message-small" *ngIf="rejectionCommentRequired && rejectionDescription.length < 1">* Required</p>
  </div>
  <ng-template #footer>
    <button (click)="close(false)" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Cancel
    </button>
    <button (click)="rejectRequisition()" class="float-right" style="margin-right:10px;margin-left:10px"
            [disabled]="selectedRejectionType.length == 0 || (rejectionCommentRequired && rejectionDescription.length < 1)">
      <i class="fa fa-save"></i> Reject
    </button>
  </ng-template>
</p-dialog>
